export {};
type FlashToast = {
    type: "success" | "info" | "warning" | "error";
    message: string;
    title?: string | null;
    options?: Record<string, any>;
};

declare global {
    interface Window {
        CRM_TOAST_PAYLOAD?: FlashToast[];
        __crmFlashToasts?: FlashToast[];
    }
}

(function bootstrap() {
    const items = (window as any).__crmToastPayload;

    if (!Array.isArray(items) || !items.length) return;

    window.__crmFlashToasts = (window.__crmFlashToasts ?? []).concat(items);

    const fire = () => {
        const queued = window.__crmFlashToasts ?? [];
        window.dispatchEvent(new CustomEvent("crm:flash-toasts", { detail: queued }));
        window.__crmFlashToasts = [];
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", fire, { once: true });
    } else {
        setTimeout(fire, 0);
    }
})();
